import { systemConstants } from "../constants";

const systemReducer = (
  state = {
    customer: null,
    user: null,
    catalogueSelected: null,
    hidePrice: localStorage.getItem("hidePrice") === "true",
    tab: null,
    offsetTop: 0,
    minimizedUi: false,
    activeNavButton: null,
  },
  action,
) => {
  switch (action.type) {
    case systemConstants.CUSTOMER_MODEL_DELETE:
      return {
        ...state,
        customer: [],
      };

    case systemConstants.TAB:
      return {
        ...state,
        tab: action.payload.tab,
      };

    case systemConstants.CUSTOMER_MODEL_UPDATE:
      return {
        ...state,
        customer: action.payload.model,
      };

    case systemConstants.USER_MODEL_DELETE:
      return {
        ...state,
        user: [],
      };

    case systemConstants.USER_MODEL_UPDATE:
      return {
        ...state,
        user: action.payload.model,
      };

    case systemConstants.CATALOGUE_SELECTION_CLOSE:
      return {
        ...state,
        catalogueSelected: null,
      };

    case systemConstants.CATALOGUE_SELECTION_OPEN:
      return {
        ...state,
        catalogueSelected: action.payload.id,
      };

    case systemConstants.HIDE_PRICE:
      return {
        ...state,
        hidePrice: action.payload.hidePrice,
      };

    case systemConstants.SET_OFFSET_TOP:
      return {
        ...state,
        offsetTop: action.payload,
      };
    case systemConstants.MINIMIZE_UI:
      return {
        ...state,
        minimizedUi: action.payload,
      };
    case systemConstants.TOGGLE_MOBILE_NAV_BUTTON:
      return {
        ...state,
        activeNavButton: action.payload,
      };
    default:
      return state;
  }
};

export default systemReducer;
